import {React,useState,useEffect} from "react";

import "../Navbar.css";
import "../pages/styles.css";
import { NavLink } from "react-router-dom";
import  Kermis_logo from "../images/Kermis_logo.png"


export default function Nav(){
     const [showTesting,setShowTesting] = useState(false);
     // const [imgSrc,setImgSrc] = useState();

     useEffect(() => {
          if(showTesting)  {
               const timer = setTimeout(() => {
                    setShowTesting(!showTesting);
               },2000);
               return () => clearTimeout(timer);
          }
     }, [showTesting]);



     // const handleTestingClick = (newImg) => {
     //      setImgSrc(newImg)
     //      setShowTesting(true)
     // }

  return(<div className="navbar" >
     
          <div className={'ballet-pagesTitle'} style={{backgroundColor:'black',border:'20',alignContent:'center'}}>
               <img src={Kermis_logo} style={{justifyContent:'center'}} />
               Kermis Club
          </div>
          
          <div style={{backgroundColor:'#d0d5db',border:'0',alignItems:'center'}}>
          
               <ul className="nav-links">
                    <NavLink to="/" className={({ isActive }) =>
                                                  isActive ? 'nav-links active' : 'nav-links'
                                                  }>
                                             <button  className={`boldFancyHeadFontCenter2`} style={{backgroundColor:'#d0d5db',border:'0'}} >
                                                  Home 
                                             </button>
                    </NavLink>
                    <NavLink to="/AboutUs" className={({ isActive }) =>
                                                  isActive ? 'nav-links active' : 'nav-links'
                                                  }>
                                             <button className={`boldFancyHeadFontCenter2`} style={{backgroundColor:'#d0d5db',border:'0'}} >
                                                  About Us 
                                             </button>
                    </NavLink>
                    <NavLink to="/LeadUs" className={({ isActive }) =>
                                                  isActive ? 'nav-links active' : 'nav-links'
                                                  }>
                                             <button className={`boldFancyHeadFontCenter2`} style={{backgroundColor:'#d0d5db',border:'0'}} >
                                                  Our Leaders 
                                             </button>
                    </NavLink>
                    
                    
                    <NavLink style={{width: '100%', display: 'flex'}}>
                    <div className="dropdown" style={{width: '120%', display: 'flex', justifyContent: 'space-around'}}>
                         <button className={"dropbutton"+ " " + `boldFancyHeadFontCenter2`} style={{backgroundColor:'#d0d5db',border:'0'}}>Galleries/Events</button>
                         <div className="dropdown-content"  style={{width:'120%',backgroundColor:'#d0d5db',border:'0'}}>
                              <NavLink to="/InMemorium" className={({ isActive }) =>
                                                  isActive ? 'nav-links active' : 'nav-links'
                                                  }>
                                                  <button className={`boldFancyHeadFontCenter2`} type="button" style={{backgroundColor:'#d0d5db',border:'0'}} >
                                                  In Memorium 
                                             </button>
                              </NavLink>
                              <NavLink to="/CurrentPlans" className={({ isActive }) =>
                                                  isActive ? 'nav-links active' : 'nav-links'
                                                  }>
                                             <button className={`boldFancyHeadFontCenter2`}  type="button" style={{backgroundColor:'#d0d5db',border:'0'}} >
                                                  2025-2026 Events
                                             </button>
                              </NavLink>
                              <NavLink to="/PastEvents" className={({ isActive }) =>
                                                  isActive ? 'nav-links active' : 'nav-links'
                                                  }>
                                             <button className={`boldFancyHeadFontCenter2`} type="button" style={{backgroundColor:'#d0d5db',border:'0'}} >
                                                  Past Events 
                                             </button>
                              </NavLink>
                              
                         </div>
                    </div>
                    </NavLink>
                    <NavLink style={{width: '100%', display: 'flex'}}>
                    <div className="dropdown" style={{width: '120%', display: 'flex', justifyContent: 'space-around',backgroundColor:'#d0d5db'}}>
                         <button className={"dropbutton"+ " " + `boldFancyHeadFontCenter2`} style={{width:'120%',backgroundColor:'#d0d5db',border:'0'}}>Membership Info</button>
                         <div className="dropdown-content"  style={{width:'120%',backgroundColor:'#d0d5db',border:'0'}}>
                              <NavLink to="/Instructions" className={({ isActive }) =>
                                                  isActive ? 'nav-links active' : 'nav-links'
                                                  }>
                                             <button className={`boldFancyHeadFontCenter2`}  type="button" style={{backgroundColor:'#d0d5db',border:'0'}} >
                                                  Membership Process/Costs and Fees
                                             </button>
                              </NavLink>
                              <NavLink to="/Application" className={({ isActive }) =>
                                                  isActive ? 'nav-links active' : 'nav-links'
                                                  }>
                                                  <button className={`boldFancyHeadFontCenter2`} type="button" style={{backgroundColor:'#d0d5db',border:'0'}} >
                                                  Membership Application/Renewal/Update
                                             </button>
                              </NavLink>
                              <NavLink to="/Payments" className={({ isActive }) =>
                                                  isActive ? 'nav-links active' : 'nav-links'
                                                  }>
                                             <button className={`boldFancyHeadFontCenter2`} type="button" style={{backgroundColor:'#d0d5db',border:'0'}} >
                                                  Electronic Payment Instructions
                                             </button>
                              </NavLink>
                              
                         </div>
                         
                    </div>
                    </NavLink>
                    <NavLink to="/ContactUs" className={({ isActive }) =>
                                                  isActive ? 'nav-links active' : 'nav-links'
                                                  }>
                                             <button className={`boldFancyHeadFontCenter2`} type="button" style={{backgroundColor:'#d0d5db',border:'0'}} >
                                                  Contact Us 
                                             </button>
                    </NavLink>
               </ul>
        </div>
</div>
  );

}